const monthNames = [
    'Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie',
    'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'
  ];

export function calculateNextProducts() {
    const today = new Date();
    let products = [];

    for (let i = 1; i <= 3; i++) {
        const futureDate = new Date(today.getFullYear(), today.getMonth() + i, 1);
        const monthName = monthNames[futureDate.getMonth()];
        const year = futureDate.getFullYear();
        products.push({
            product: `${monthName} ${year}`,
            code: `M${i}`
        })
      }

    const currentQuarter = Math.floor(today.getMonth() / 3) + 1;

    for (let i = 1; i <= 3; i++) {
        let quarter = currentQuarter + i;
        let year = today.getFullYear();
      
        if (quarter > 4) {
          quarter = ((quarter - 1) % 4) + 1; // revine la 1 după 4
          year += Math.floor((currentQuarter + i - 1) / 4); // adaugă an dacă e necesar
        }
        products.push({
            product: `Trimestrul ${quarter} ${year}`,
            code: `Q${i}`
        })
    }

    for (let i = 1; i <= 2; i++) {
        const year = today.getFullYear() + i;
        products.push({
            product: `Anul ${year}`,
            code: `Y${i}`
        })
    }
    return products;
};


export function areDatesEqualIgnoringTime(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
